//carusel
import img1 from '../Images/escritorio/Index/carousel/1.jpg';
import img2 from '../Images/escritorio/Index/carousel/2.jpg';
import img3 from '../Images/escritorio/Index/carousel/3.jpg';
import img4 from '../Images/escritorio/Index/carousel/4.jpg';
import img5 from '../Images/escritorio/Index/carousel/5.jpg';
import img6 from '../Images/escritorio/Index/carousel/6.jpg';
import img7 from '../Images/escritorio/Index/carousel/7.jpg';
import img8 from '../Images/escritorio/Index/carousel/8.jpg';
import img9 from '../Images/escritorio/Index/carousel/9.jpg';
import img10 from '../Images/escritorio/Index/carousel/10.jpg';
import img11 from '../Images/escritorio/Index/carousel/11.jpg';
import img12 from '../Images/escritorio/Index/carousel/12.jpg';
import img13 from '../Images/escritorio/Index/carousel/13.jpg';

const imagenes = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13
];

export default imagenes;